<script>
import ChooseLocale2 from "./ChooseLocale-2.vue";

export default {
  components: { ChooseLocale2 },
  name: "AuthHeader",

  props: {
    title: String,
  },

  data: () => ({
    //
  }),
};
</script>

<template>
  <div class="auth-wrap">
    <div class="auth-content-wrap">
      <div class="d-flex justify-end">
        <choose-locale-2 />
      </div>
      <div class="auth-logo">
        <img src="../assets/img/logo-inline.png" alt="" />
      </div>

      <div class="auth-content">
        <div class="auth-title">{{ title }}</div>

        <slot />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.auth-wrap {
  background-color: var(--v-secondary-base);

  > * {
    font-family: "Roboto", sans-serif !important;
  }

  min-height: 100vh;

  display: flex;
  align-items: center;
  justify-content: center;

  .auth-content-wrap {
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 10px;
    padding-right: 10px;

    max-width: 700px;
    width: 100%;
    color: white;

    .auth-logo {
      text-align: center;
      padding-bottom: 30px;
      img {
        max-width: 300px;
      }
    }

    .auth-content {
      background-color: var(--v-accent-base);

      width: 100%;

      padding: 15px;
      border-radius: 10px;

      @media only screen and(min-width:480px) {
        padding: 40px;
      }

      .auth-title {
        padding-bottom: 15px;
        margin-bottom: 50px;
        text-align: center;
        font-size: 22px;
        font-weight: 600;
        color: #fff;
        border-bottom: 1px solid #eee;
      }
    }

    @media only screen and(min-width:2020px) {
      display: flex;
      align-items: center;
      justify-content: space-between;
      max-width: 1300px;
      .auth-logo {
        padding-right: 50px;
        padding-bottom: 0;
      }
    }
  }
}
</style>
